import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../services/alert.service';
import {EnvService} from '../services/env.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'micro-cmdb-disk-type-detail',
  templateUrl: './cmdb-disk-type-detail.component.html'
})
export class CmdbDiskTypeDetailComponent implements OnInit {
  @Input() cmdbDiskTypeId: any;
  @Output() persisted = new EventEmitter<any>();
  cmdbDiskType: any;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient, private route: ActivatedRoute,
              private router: Router, private alertService: AlertService) {
  }

  ngOnInit(): void {
    if (this.cmdbDiskTypeId) {
      this.load(this.cmdbDiskTypeId);

    } else {
      this.route.params.subscribe((params: Params) => {
        params['id'] === '0' ? this.createNew() : this.load(params['id']);
      });
    }
  }

  load(id: string): void {
    this.http.get(`${this.env.e.url}/domain/cmdbDiskTypes/${id}`).subscribe(data => {
      this.cmdbDiskType = data;
    });
  }

  createNew(): void {
    this.cmdbDiskType = { name: '', description: '', active: 'N', companyId: this.auth.getCompanyId() };
  }

  save(): void {
    const isUpdate = !!this.cmdbDiskType.id;
    const request = isUpdate
      ? this.http.put(`${this.env.e.url}/domain/cmdbDiskTypes/${this.cmdbDiskType.id}`, this.cmdbDiskType)
      : this.http.post(`${this.env.e.url}/domain/cmdbDiskTypes`, this.cmdbDiskType);
    request.subscribe(data => {
      this.cmdbDiskType = data;
      this.alertService.info(`${isUpdate ? 'Updated' : 'Created'} ${this.cmdbDiskType.name}`);
      this.persisted.emit({data, action: isUpdate ? 'updated' : 'added'});
    });
  }

  delete(): void {
    this.http.delete(`${this.env.e.url}/domain/cmdbDiskTypes/${this.cmdbDiskType.id}`).subscribe(() => {
      this.persisted.emit({data: this.cmdbDiskType, action: 'deleted'});
      this.alertService.info(`Deleted ${this.cmdbDiskType.name}`);
      if (!this.cmdbDiskTypeId) { this.router.navigate(['/diskTypes']); }
    });
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.cmdbDiskType.active = target.checked ? 'Y' : 'N';
  }
}
